import React from "react";

const WhatsAppButton = () => (
  <a
    href="https://wa.me/34623224305"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-button"
    aria-label="WhatsApp"
    className="flex items-center justify-center w-11 h-11 sm:w-14 sm:h-14 rounded-full bg-[#25D366] shadow-[0_6px_20px_rgba(37,211,102,0.5)] hover:scale-110 transition-transform duration-200"
  >
    <svg viewBox="0 0 32 32" width="30" height="30" fill="#fff" aria-hidden="true">
      <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.463 1.712 6.41L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.234 1.59h.005c7.06 0 12.8-5.74 12.8-12.8s-5.744-12.67-12.805-12.67zm0 23.02h-.004a10.62 10.62 0 0 1-5.41-1.48l-.388-.23-4.03 1.055 1.076-3.93-.253-.403a10.6 10.6 0 0 1-1.626-5.65c0-5.87 4.777-10.646 10.65-10.646 2.845 0 5.518 1.11 7.53 3.123a10.58 10.58 0 0 1 3.117 7.53c0 5.872-4.777 10.65-10.65 10.65zm5.84-7.976c-.32-.16-1.894-.935-2.188-1.042-.293-.106-.507-.16-.72.16-.213.32-.826 1.042-1.013 1.256-.187.213-.373.24-.693.08-.32-.16-1.352-.498-2.576-1.59-.952-.848-1.594-1.895-1.78-2.215-.187-.32-.02-.494.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.736-.987-2.376-.26-.624-.524-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.095-1.12 2.67 0 1.575 1.147 3.097 1.307 3.31.16.213 2.256 3.445 5.467 4.83.764.33 1.36.527 1.824.674.767.244 1.464.21 2.016.127.615-.092 1.894-.774 2.16-1.522.267-.747.267-1.388.187-1.522-.08-.133-.293-.213-.613-.373z"/>
    </svg>
  </a>
);

export default WhatsAppButton;
